import { render, staticRenderFns } from "./GrossSales.vue?vue&type=template&id=5867816b&scoped=true&"
import script from "./GrossSales.vue?vue&type=script&lang=js&"
export * from "./GrossSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867816b",
  null
  
)

export default component.exports